export default "__VITE_ASSET__Cha56mty__"